module.exports = __webpack_public_path__ + "static/media/img-1.c7a65194.png";